import { render, staticRenderFns } from "./POS-invoiceList.vue?vue&type=template&id=89a23250"
import script from "./POS-invoiceList.vue?vue&type=script&lang=js"
export * from "./POS-invoiceList.vue?vue&type=script&lang=js"
import style0 from "./POS-invoiceList.vue?vue&type=style&index=0&id=89a23250&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports